import { render, staticRenderFns } from "./receiptedGoods.vue?vue&type=template&id=9335f646&scoped=true&"
import script from "./receiptedGoods.vue?vue&type=script&lang=js&"
export * from "./receiptedGoods.vue?vue&type=script&lang=js&"
import style0 from "./receiptedGoods.vue?vue&type=style&index=0&id=9335f646&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9335f646",
  null
  
)

export default component.exports